import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogActionButtonsComponent } from '../../shared/dialog-action-buttons/dialog-action-buttons.component';
import { Subject, takeUntil } from 'rxjs';
import { DialogService } from '../../../../../core/services/dialog/dialog.service';
import { ToastService } from '../../../../../core/services/toast/toast.service';
import { FirstTimeLoginApiService } from '../../../../../pages/auth/first-time-login/first-time-login-api.service';
import { PasswordInputComponent } from '../../../form-controls/password-input/password-input.component';
import { FormValidatorService } from '../../../../../core/services/form-validator/form-validator.service';
import { LoginService } from '../../../../../pages/auth/login/login.service';
import { DelegatedUIErrorI } from '../../../../interfaces/delegated-ui-error.interface';
import { AUTH_VALIDATION } from '../../../../../pages/settings/change-password/constants/auth-validation.constant';

@Component({
  selector: 'app-new-password',
  imports: [
    TranslateModule,
    DialogActionButtonsComponent,
    ReactiveFormsModule,
    FormsModule,
    PasswordInputComponent,
  ],
  templateUrl: './new-password.component.html',
  styleUrl: './new-password.component.scss',
})
export class NewPasswordComponent implements OnInit, OnDestroy {
  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly dialogService: DialogService,
    private readonly toastService: ToastService,
    private readonly firstTimeLoginApiService: FirstTimeLoginApiService,
    private readonly loginService: LoginService
  ) {}

  private readonly destroy$ = new Subject<void>();
  @Input({ required: true })
  email!: string;
  @Input({ required: true })
  otp!: string;

  setNewPasswordForm = this.fb.group({
    otp: [
      '',
      [Validators.minLength(6), Validators.maxLength(6), Validators.required],
    ],
    email: [
      '',
      [Validators.required, Validators.minLength(3), Validators.maxLength(320)],
    ],
    password: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_VALIDATION.PASSWORD.MIN_LENGTH),
        Validators.maxLength(AUTH_VALIDATION.PASSWORD.MAX_LENGTH),
        FormValidatorService.lowercaseLetters(),
        FormValidatorService.specialCharacters(),
        FormValidatorService.numbers(),
        FormValidatorService.uppercaseLetters(),
      ],
    ],
    confirmPassword: [
      '',
      [
        Validators.required,
        Validators.minLength(AUTH_VALIDATION.PASSWORD.MIN_LENGTH),
        Validators.maxLength(AUTH_VALIDATION.PASSWORD.MAX_LENGTH),
        FormValidatorService.lowercaseLetters(),
        FormValidatorService.specialCharacters(),
        FormValidatorService.numbers(),
        FormValidatorService.uppercaseLetters(),
      ],
    ],
  });

  ngOnInit(): void {
    this.setNewPasswordForm.controls.email.setValue(this.email);
    this.setNewPasswordForm.controls.otp.setValue(this.otp);
  }

  onSubmit() {
    this.firstTimeLoginApiService
      .setNewPassword(this.setNewPasswordForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (loginResponse) => {
          this.dialogService.closeDialog();

          this.loginService.initLoginState(loginResponse);
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
